import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { juice } from '@/mocks/products';
import { Link } from 'react-router-dom';

const JuicePage = () => {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/3176550dc6d2034f23f2f144ca1f95a4.jpg"
              alt="Parreirais para suco de uva integral"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/25"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
            <span className="inline-block bg-white/15 text-white text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5 backdrop-blur-sm">
              100% Natural
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 max-w-2xl leading-tight">
              Suco de Uva Integral
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-md leading-relaxed mb-8">
              Extraído diretamente das uvas, sem adição de água ou açúcar. Puro sabor da natureza em cada gole.
            </p>
            <a
              href="https://wa.me/5500000000000"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-emerald-700 text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-emerald-800 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              Pedir pelo WhatsApp
            </a>
          </div>
        </section>

        {/* Product Spotlight */}
        <section className="py-20 md:py-28 bg-[#faf7f5]">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16">
              {/* Image */}
              <div className="w-full lg:w-5/12 flex justify-center">
                <div className="relative flex flex-col items-center">
                  <div className="w-72 h-72 md:w-96 md:h-96 rounded-full bg-gradient-to-br from-purple-100 to-emerald-100 flex items-center justify-center">
                    <img
                      src={juice.image}
                      alt="Suco de Uva Integral"
                      className="h-72 md:h-88 w-auto object-contain drop-shadow-xl"
                      style={{ maxHeight: 340 }}
                    />
                  </div>
                  <div className="w-24 h-2 rounded-full bg-black/15 blur-sm -mt-2"></div>
                  <div className="absolute -top-4 -right-4 bg-emerald-700 text-white rounded-2xl px-4 py-3 text-center">
                    <p className="text-xl font-bold">0%</p>
                    <p className="text-xs text-white/80">Açúcar</p>
                  </div>
                  <div className="absolute -bottom-4 -left-4 bg-[#6B1E1E] text-white rounded-2xl px-4 py-3 text-center">
                    <p className="text-xl font-bold">100%</p>
                    <p className="text-xs text-white/80">Integral</p>
                  </div>
                </div>
              </div>
              {/* Text */}
              <div className="w-full lg:w-7/12">
                <span className="inline-block bg-emerald-50 text-emerald-800 text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5">
                  Puro e Natural
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1a0a0a] mb-5 leading-snug">
                  Toda a Saúde da Uva em um Único Produto
                </h2>
                <p className="text-[#7a5555] text-sm md:text-base leading-relaxed mb-6">
                  {juice.description} Nosso suco de uva integral é produzido com o mesmo cuidado artesanal dos nossos vinhos, preservando todos os nutrientes e o sabor autêntico da uva. Sem água, sem açúcar — só uva.
                </p>
                <div className="grid grid-cols-2 gap-4 mb-8">
                  {[
                    { label: 'Sem água', icon: 'ri-contrast-drop-line' },
                    { label: 'Sem açúcar', icon: 'ri-close-circle-line' },
                    { label: '100% Integral', icon: 'ri-shield-check-line' },
                    { label: 'Sem corantes', icon: 'ri-palette-line' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-center gap-2.5 bg-white rounded-xl p-3">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-50 text-emerald-700 flex-shrink-0">
                        <i className={`${item.icon} text-sm`}></i>
                      </span>
                      <span className="text-sm font-medium text-[#1a0a0a]">{item.label}</span>
                    </div>
                  ))}
                </div>
                <a
                  href="https://wa.me/5500000000000"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-emerald-700 text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-emerald-800 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line"></i>
                  Fazer Pedido Agora
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 md:py-28 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-14">
              <span className="text-emerald-700 text-xs font-semibold tracking-widest uppercase">Saúde & Bem-Estar</span>
              <h2 className="mt-3 text-3xl md:text-4xl font-bold text-[#1a0a0a]">Benefícios do Suco de Uva Integral</h2>
              <p className="mt-4 text-[#7a5555] text-sm max-w-lg mx-auto">
                Ciência e natureza juntas. Veja o que um copo de suco de uva integral pode fazer pelo seu organismo.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {juice.benefits.map((benefit) => (
                <div key={benefit.title} className="bg-[#faf7f5] rounded-2xl p-6 hover:-translate-y-1 transition-all duration-200">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-700 mb-5">
                    <i className={`${benefit.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-bold text-[#1a0a0a] text-base mb-2">{benefit.title}</h3>
                  <p className="text-[#7a5555] text-xs leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison */}
        <section className="py-20 bg-[#faf7f5]">
          <div className="max-w-5xl mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-[#1a0a0a]">Por que Integral?</h2>
              <p className="mt-3 text-[#7a5555] text-sm">Entenda a diferença que faz para a sua saúde.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 border-2 border-[#f0e0d8]">
                <div className="flex items-center gap-3 mb-5">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-red-50 text-red-500 flex-shrink-0">
                    <i className="ri-close-line text-lg"></i>
                  </span>
                  <h3 className="font-bold text-[#1a0a0a]">Suco Comum</h3>
                </div>
                <ul className="space-y-2.5">
                  {['Adição de água', 'Açúcar refinado', 'Conservantes artificiais', 'Corantes', 'Sabor artificial'].map((item) => (
                    <li key={item} className="flex items-center gap-2 text-sm text-[#7a5555]">
                      <i className="ri-close-circle-line text-red-400"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-emerald-700 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-5">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white flex-shrink-0">
                    <i className="ri-check-line text-lg"></i>
                  </span>
                  <h3 className="font-bold text-white">Nosso Suco Integral</h3>
                </div>
                <ul className="space-y-2.5">
                  {['100% suco de uva puro', 'Zero açúcar adicionado', '100% integral', 'Sem corantes', 'Sabor natural autêntico'].map((item) => (
                    <li key={item} className="flex items-center gap-2 text-sm text-white/90">
                      <i className="ri-check-double-line text-emerald-200"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-emerald-700">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Experimente o Suco Puro da Uva</h2>
            <p className="text-white/80 text-sm mb-8">Saúde e sabor em cada gole. Peça agora mesmo!</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="https://wa.me/5500000000000" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-2 bg-white text-emerald-700 px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line"></i> Pedir pelo WhatsApp
              </a>
              <Link to="/#contato" className="flex items-center gap-2 bg-white/15 text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line"></i> Enviar Mensagem
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default JuicePage;
